import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'shards-react';

const FloatingButton = styled(Button)`
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1000;
    border-radius: 50px;
    padding: 15px;
    background-color: #007bff;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
    transition: all 0.3s ease;
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
        transform: translateY(-50%) scale(1.05);
    }
    
    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    }
`;

const DocContainer = styled.div<{ isVisible: boolean }>`
    position: fixed;
    top: 0;
    right: ${props => props.isVisible ? '0' : '-100%'};
    width: 50vw;
    height: 100vh;
    background: white;
    z-index: 999;
    transition: right 0.3s ease-in-out;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
`;

const DocHeader = styled.div`
    padding: 15px 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const CloseButton = styled(Button)`
    padding: 5px 10px;
    background-color: #6c757d;
    border: none;
    border-radius: 4px;
    
    &:hover {
        background-color: #5a6268;
    }
`;

const IframeContainer = styled.div`
    flex: 1;
    padding: 0;
    overflow: hidden;
`;

const DocumentIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    display: block;
`;

const Overlay = styled.div<{ isVisible: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 998;
    opacity: ${props => props.isVisible ? '1' : '0'};
    visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
    transition: all 0.3s ease-in-out;
`;

interface GoogleDocEmbedProps {
    docUrl?: string;
    title?: string;
}

const GoogleDocEmbed: React.FC<GoogleDocEmbedProps> = ({ 
    docUrl = "https://docs.google.com/document/d/e/2PACX-1vSH-5xxmEc283KtDC5z_v2Ydczu6LUz6ok_0W28A462tofdmhSi4AiPxNhcAwBsNI_XdHAPxY4yLAIt/pub?embedded=true",
    title = "Documentation"
}) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const closeDoc = () => {
        setIsVisible(false);
    };

    return (
        <>
            <FloatingButton 
                onClick={toggleVisibility}
                title={isVisible ? "Close Documentation" : "Open Documentation"}
            >
                {isVisible ? '✕' : '📖'}
            </FloatingButton>
            
            <Overlay isVisible={isVisible} onClick={closeDoc} />
            
            <DocContainer isVisible={isVisible}>
                <DocHeader>
                    <h5 style={{ margin: 0, color: '#495057' }}>{title}</h5>
                    <CloseButton onClick={closeDoc}>
                        ✕
                    </CloseButton>
                </DocHeader>
                <IframeContainer>
                    <DocumentIframe 
                        src={docUrl}
                        title={title}
                    />
                </IframeContainer>
            </DocContainer>
        </>
    );
};

export default GoogleDocEmbed; 